const styles = theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    marginTop: theme.spacing(2),
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  headerTitle: {
    fontSize: '14px',
    fontWeight: 500,
    color: '#000',
  },
  goalsList: {
    display: 'flex',
    flexDirection: 'column',
  },
  goalItem: {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: theme.spacing(1.5),
    borderRadius: '4px',
    gap: '4px',
  },
  goalNumber: {
    fontSize: '14px',
    fontWeight: 400,
    minWidth: '20px',
    paddingTop: '2px',
  },
  goalText: {
    fontSize: '14px',
    fontWeight: 400,
    flex: 1,
    outline: 'none',
    minHeight: '20px',
    position: 'relative',
    wordBreak: 'break-word',
    '&[data-placeholder]:empty:before': {
      content: 'attr(data-placeholder)',
      color: '#838D98',
      pointerEvents: 'none',
      position: 'absolute',
    },
  },
  closeIcon: {
    cursor: 'pointer',
    color: '#838D98',
    fontSize: '20px',
    marginTop: '2px',
  },
  addButton: {
    alignSelf: 'flex-start',
  },
  popupContent: {
    padding: '8px',
  },
  popupTitle: {
    color: '#637381',
  },
  popupTitleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px',
  },
  suggestionList: {
    padding: 0,
    maxHeight: '200px',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  suggestionItem: {
    borderRadius: '8px',
    padding: '12px 8px',
    display: 'flex',
    alignItems: 'flex-start',
    gap: '8px',
    '&:hover': {
      backgroundColor: '#F4F6F8',
    },
    '&:last-child': {
      marginBottom: theme.spacing(1),
    },
  },
  suggestionText: {
    color: '#637381',
    lineHeight: 1.4,
  },
  suggestionItemIcon: {
    display: 'flex',
    width: '24px',
    height: '24px',
    minWidth: '24px',
    [theme.breakpoints.down('md')]: {
      width: '16px',
      height: '16px',
      minWidth: '16px',
      minHeight: '16px',
    },
  },
})

export default styles
